import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

type Props = {
  children: React.ReactElement;
  rolRequerido?: string;
};

export default function PrivateRoute({ children, rolRequerido }: Props) {
  const { user } = useAuth(); // ✅ Usamos "user" si ese es el nombre en AuthContext
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (rolRequerido && user.rol !== rolRequerido) {
    return <Navigate to="/no-autorizado" replace />;
  }

  return children;
}
